import { render } from "./Personas.vue?vue&type=template&id=2c55ba28&scoped=true"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"

import "./Personas.vue?vue&type=style&index=0&id=2c55ba28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c55ba28"]])

export default __exports__